import { useQueryState } from '@pinia/colada'
import type { EntryKey } from '@pinia/colada'

export const useQueryStateExtended = (key: EntryKey) => {
  const { isPending, state, status, error } = useQueryState(key)

  const isInitialized = computed(() => state.value !== undefined)
  const isFetching = computed(
    () => isInitialized.value && status.value === 'pending',
  )
  const isError = computed(() => status.value === 'error')

  return {
    error,
    isError,
    isFetching,
    isInitialized,
    isPending,
    status,
    state,
  }
}
